import {useMutation} from '@apollo/react-hooks';

import type {CreateEntriConfigVariables} from 'nutshell-graphql-types';

import CREATE_ENTRI_CONFIG from '../mutations/create-entri-config.graphql';

export function useCreateEntriConfig(): {
    createEntriConfig: (variables: CreateEntriConfigVariables) => Promise<any | null | undefined>;
    isCreating: boolean;
} {
    const [createEntriConfig, {loading: isCreating}] = useMutation(CREATE_ENTRI_CONFIG);

    const handleCreateEntriConfig = async (variables: CreateEntriConfigVariables) => {
        return createEntriConfig({variables}).then((response) => {
            if (response.data) {
                return JSON.parse(response.data.entriConfigCreate);
            }

            return null;
        });
    };

    return {
        createEntriConfig: handleCreateEntriConfig,
        isCreating,
    };
}
